const getDefaultState = () => ({
  idFlux: '',
  executionCode: '',
  fnolMavalueReportComponent: '',
  damagesConfirmed: false,
  isWldFlow: false,
  wldConnection: null,
  wldWithAppointment: null
})

export {
  getDefaultState
}
